export default [
  {
    path: '/providers',
    name: 'providers',
    component: () =>
      import(
        /* webpackChunkName: "providers" */ '@/view/pages/providers/Provider.vue'
      ),
    children: [
      {
        path: '/',
        name: 'list-provider',
        component: () =>
          import(
            /* webpackChunkName: "providers-list" */ '@/view/pages/providers/ListProvider.vue'
          ),
        meta: {
          title: 'Danh sách nhà cung cấp - Clickbuy',
        },
      },
      {
        path: 'add-provider',
        name: 'add-provider',
        component: () =>
          import(
            /* webpackChunkName: "providers-add" */ '@/view/pages/providers/AddProvider.vue'
          ),
        meta: {
          title: 'Thêm mới nhà cung cấp - Clickbuy',
        },
      },
      {
        path: 'update-provider',
        name: 'update-provider',
        component: () =>
          import(
            /* webpackChunkName: "providers-update" */ '@/view/pages/providers/UpdateProvider.vue'
          ),
        meta: {
          title: 'Cập nhật nhà cung cấp - Clickbuy',
        },
      },
    ],
  },
];
